module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loaded && _vm.selectedMeeting) ? _c('div', {
    staticClass: "widget"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("\n        Live Session File Share"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (
        'A place to share files with your supervisor for each live session'
      ),
      expression: "\n            'A place to share files with your supervisor for each live session'\n          "
    }],
    staticClass: "clippie fa fa-info-circle"
  }), _c('i', {
    staticClass: "fa fa-refresh",
    on: {
      "click": function($event) {
        _vm.getMeetings()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "toggle-widget",
    on: {
      "click": function($event) {
        _vm.toggle()
      }
    }
  }, [_c('i', {
    class: _vm.toggleClass
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }],
    staticClass: "panel-body"
  }, [(_vm.roles.includes('Supervisor') || _vm.roles.includes('Student')) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.termId),
      expression: "termId"
    }],
    attrs: {
      "disabled": _vm.selectedMeeting.downloading
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.termId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.changeTerm()
      }]
    }
  }, _vm._l((_vm.terms), function(term, $index) {
    return _c('option', {
      key: term.id,
      domProps: {
        "value": $index
      }
    }, [_vm._v("\n          " + _vm._s(term.name) + "\n        ")])
  })) : _vm._e(), _vm._v(" "), (_vm.roles.includes('Supervisor')) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.groupId),
      expression: "groupId"
    }],
    attrs: {
      "disabled": _vm.selectedMeeting.downloading
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.groupId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.changeGroup()
      }]
    }
  }, _vm._l((_vm.terms[_vm.termId].studentGroup), function(group, $index) {
    return _c('option', {
      key: group.id,
      domProps: {
        "value": $index
      }
    }, [_vm._v("\n          " + _vm._s(group.label) + "\n        ")])
  })) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.meetingId),
      expression: "meetingId"
    }],
    attrs: {
      "disabled": _vm.selectedMeeting.downloading
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.meetingId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.terms[_vm.termId].studentGroup[_vm.groupId].meetings), function(meeting) {
    return _c('option', {
      key: meeting.id,
      domProps: {
        "value": meeting.id
      }
    }, [_vm._v("\n          " + _vm._s(_vm.meetingTitle(meeting)) + "\n        ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "meeting"
  }, [(_vm.selectedMeeting.users.length == 0) ? _c('div', [_vm._v("\n          No files have been shared.\n        ")]) : (_vm.roles.includes('Supervisor') && _vm.selectedMeeting.users.length > 1 && !_vm.selectedMeeting.downloading) ? _c('span', {
    staticClass: "downloadAll",
    on: {
      "click": function($event) {
        _vm.downloadAllStudents()
      }
    }
  }, [_vm._v("Download All Student Files")]) : _vm._e(), _vm._v(" "), (_vm.selectedMeeting.downloading) ? _c('span', [_vm._v("Downloading All Student Files..."), _c('i', {
    staticClass: "fa fa-ban",
    on: {
      "click": function($event) {
        _vm.cancelDownload(_vm.selectedMeeting)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.selectedMeeting.users), function(user) {
    return _c('div', {
      key: user.id
    }, [_c('div', {
      staticClass: "user"
    }, [_vm._v(" " + _vm._s(_vm.username(user)) + "\n            "), (!user.downloading) ? _c('span', {
      staticClass: "downloadAll",
      on: {
        "click": function($event) {
          _vm.downloadAll(user)
        }
      }
    }, [_vm._v("(Download All)")]) : (user.zipping) ? _c('span', [_vm._v("(Zipping...)")]) : _c('span', [_vm._v("(Downloading...)"), (!_vm.selectedMeeting.downloading) ? _c('i', {
      staticClass: "fa fa-ban",
      on: {
        "click": function($event) {
          _vm.cancelDownload(user)
        }
      }
    }) : _vm._e()])]), _vm._v(" "), _vm._l((user.files), function(file, file_index) {
      return _c('div', {
        key: file.id,
        staticClass: "file"
      }, [_c('a', {
        attrs: {
          "href": file.url,
          "download": file.name
        }
      }, [_vm._v("\n              " + _vm._s(_vm.filename(file)) + _vm._s(file.deleting ? " deleting..." : "") + "\n            ")]), _vm._v(" "), (user.downloading) ? _c('div', {
        staticClass: "downloadBar"
      }, [_c('div', {
        staticClass: "filler",
        style: ({
          width: file.progress
        })
      })]) : _vm._e(), _vm._v(" "), (!user.downloading && user.id == _vm.userId && !file.deleting) ? _c('i', {
        staticClass: "fa fa-trash",
        on: {
          "click": function($event) {
            _vm.deleteFile(file, file_index, user.files)
          }
        }
      }) : _vm._e()])
    }), _vm._v(" "), (user.zipping) ? _c('div', {
      staticClass: "zipDownloadBar"
    }, [_c('div', {
      staticClass: "filler",
      style: ({
        width: user.zipping
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "zip"
    }, [_vm._v("Zipping: " + _vm._s(user.zipfile))])]) : _vm._e()], 2)
  }), _vm._v(" "), (_vm.selectedMeeting.zipping) ? _c('div', {
    staticClass: "zipDownloadBar"
  }, [_c('div', {
    staticClass: "filler",
    style: ({
      width: _vm.selectedMeeting.zipping
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "zip"
  }, [_vm._v("Zipping: " + _vm._s(_vm.selectedMeeting.zipfile))])]) : _vm._e()], 2), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "file-upload",
      "multiple": "",
      "disabled": _vm.selectedMeeting.downloading
    },
    on: {
      "change": _vm.setFile
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.selectedMeeting.downloading
    }
  }, [_c('label', {
    class: {
      disabled: (_vm.selectedMeeting.downloading)
    },
    attrs: {
      "for": "file-upload"
    }
  }), _vm._v(_vm._s(_vm.selectedMeeting.downloading ? "Uploads Disabled" : "Upload Files(s)"))]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('loader')], 1) : _vm._e()])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3c228c3a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/LiveSessionFileShare.vue
// module id = 1997
// module chunks = 2